import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookie from 'corp-front-vue-commons/src/utils/Cookie'
import { SESSION_USER } from 'utils/constants'
import { isSapConcurRoute, persistRouteOnLocalStorage } from 'utils/functions'
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const publicRoutes = routes
    .filter(route => route.name)
    .filter(route => !route.meta || (route.meta && !route.meta.requiresAuth))
    .map(route => route.name)

  const isPublicRoute = Boolean(publicRoutes.find(route => route === to.name))
  const isPrivateRoute = !publicRoutes.includes(to.name)
  const isHybridRoute = Boolean(to.meta.hybridRoute)
  const loggedIn = Cookie.get(SESSION_USER)

  if (isSapConcurRoute()) return

  if (isHybridRoute) return next()

  if (isPrivateRoute && !loggedIn) {
    persistRouteOnLocalStorage()
    return next({ name: 'Login' })
  }

  if (isPublicRoute && loggedIn) {
    return next({ name: 'Dashboard' })
  }

  next()
})

export default router
